import reducer from './tutorials.reducer'
import listener from './tutorials.listener'

export const reducers = { tutorials: reducer }
export const services = []
export const listeners = [listener]
